/* The site's two-layer header (partials/site/header.hbs), the website's lib/header-layers.ts in plain script
   (website branch rsa/first-site at 7291ff0), which is the approved motion prototype's updateHeader. gulp
   concatenates it into assets/built/site.js before main.js, which mounts it.

   The light layer is clipped away wherever the page under the header is dark, so the header changes exactly
   where the page does, at a dark zone's edge. Each dark zone says so itself with data-header-zone, valued with
   the ground it paints, and over it the dark layer stands on that ground, so text scrolling under the header
   never shows through its white type. On the blog the zones are the footer and an article's opener, both on
   the void. Only full-width bands may be zones: a zone turns the header dark across its whole width. */
var cyHeaderLayers = (function () {
    'use strict';

    var ZONE_ATTR = 'data-header-zone';

    /* The grounds a dark band stands on, each the colour it paints, which the dark layer takes over it. */
    var GROUNDS = {
        void: '#0A0014',
        depth: '#1E0A3C',
        charcoal: '#2D2D2D'
    };

    /* The prototype's updateHeader as a pure function of the zones in document order ({kind, top, bottom}, in the
       window's coordinates) and the header's height. A zone that covers the header clips the light layer away in
       full; a zone leaving over the top clips it from the top down to the zone's bottom edge; a zone arriving from
       below clips it from the bottom up to the zone's top edge. Edges are written in whole pixels. */
    function layers(zones, height) {
        var top = 0;
        var bottom = 0;
        var full = false;
        var background = 'transparent';
        for (var i = 0; i < zones.length; i += 1) {
            var zone = zones[i];
            if (zone.top < height && zone.bottom > 0) {
                background = GROUNDS[zone.kind];
            }
            if (zone.top <= 0 && zone.bottom >= height) {
                full = true;
                break;
            }
            if (zone.bottom > 0 && zone.bottom < height && zone.top <= 0) {
                top = Math.max(top, zone.bottom);
            }
            if (zone.top > 0 && zone.top < height && zone.bottom >= height) {
                bottom = Math.max(bottom, height - zone.top);
            }
        }
        var clip = full ? 'inset(0 0 100% 0)' : 'inset(' + top.toFixed(0) + 'px 0 ' + bottom.toFixed(0) + 'px 0)';
        return { clip: clip, background: background };
    }

    /* The dark zones on the page now, in document order, where they are in the window. */
    function zonesNow(doc) {
        var zones = [];
        var found = doc.querySelectorAll('[' + ZONE_ATTR + ']');
        for (var i = 0; i < found.length; i += 1) {
            var kind = found[i].getAttribute(ZONE_ATTR);
            if (!Object.prototype.hasOwnProperty.call(GROUNDS, kind)) {
                continue;
            }
            var rect = found[i].getBoundingClientRect();
            zones.push({ kind: kind, top: rect.top, bottom: rect.bottom });
        }
        return zones;
    }

    /* Keeps the header's layers in step with the page: once now, then once a frame while the page scrolls,
       resizes or changes height. Returns the function that stops it. */
    function mount(header, dark, light) {
        var doc = header.ownerDocument;
        var win = doc.defaultView || window;
        var frame = 0;
        var clipShown = '';
        var backgroundShown = '';

        function update() {
            frame = 0;
            // the prototype's fallback height, for a header with no layout yet
            var state = layers(zonesNow(doc), header.offsetHeight || 76);
            if (state.clip !== clipShown) {
                light.style.clipPath = state.clip;
                clipShown = state.clip;
            }
            if (state.background !== backgroundShown) {
                dark.style.background = state.background;
                backgroundShown = state.background;
            }
        }

        function schedule() {
            if (!frame) {
                frame = win.requestAnimationFrame(update);
            }
        }

        update();
        win.addEventListener('scroll', schedule, { passive: true });
        win.addEventListener('resize', schedule);
        var resized = typeof win.ResizeObserver === 'function' ? new win.ResizeObserver(schedule) : null;
        if (resized) {
            resized.observe(doc.documentElement);
        }

        return function stop() {
            win.removeEventListener('scroll', schedule);
            win.removeEventListener('resize', schedule);
            if (resized) {
                resized.disconnect();
            }
            if (frame) {
                win.cancelAnimationFrame(frame);
                frame = 0;
            }
        };
    }

    return { GROUNDS: GROUNDS, ZONE_ATTR: ZONE_ATTR, layers: layers, mount: mount };
})();
